import Vue from 'vue';
import Router from 'vue-router';
import Home from '../views/Home.vue';
import UserInfoStore from '../app/user-info-store';
import UserInfoApi from '../app/user-info-api';
import VueRouterBackButton from 'vue-router-back-button'
import auth from '../app/auth';
import ErrorComponent from '@/components/Error';

// const Told = () => import(/* webpackChunkName: "told" */ '@/views/Told/ToldMain');
// const CallsignSearch = () => import(/* webpackChunkName: "callsign" */ '@/views/Callsign/CallsignSearch');
// const CallsignResults = () => import(/* webpackChunkName: "callsign" */ '@/views/Callsign/CallsignResults');
// const InProgress = () => import(/* webpackChunkName: "misc" */ '@/views/InProgress');
// const MemberInfoSelector = () => import(/* webpackChunkName: "memberinfo" */ '@/views/MemberInfo/MemberInfoSelector');
// const MemberInfoDetail = () => import(/* webpackChunkName: "memberinfo" */ '@/views/MemberInfo/MemberInfoDetail');
// const MemberInfoList = () => import(/* webpackChunkName: "memberinfo" */ '@/views/MemberInfo/MemberInfoList');
// const CheckPilotListUnits = () => import(/* webpackChunkName: "checkpilot" */ '@/views/CheckPilotList/CheckPilotListUnits');
// const CheckPilotListTypes = () => import(/* webpackChunkName: "checkpilot" */ '@/views/CheckPilotList/CheckPilotListTypes');
// const CheckPilotList = () => import(/* webpackChunkName: "checkpilot" */ '@/views/CheckPilotList/CheckPilotList');
// const CheckPilotListDetail = () => import(/* webpackChunkName: "checkpilot" */ '@/views/CheckPilotList/CheckPilotListDetail');
// const FROListGroups = () => import(/* webpackChunkName: "fro" */ '@/views/FROList/FROListGroups');
// const FROList = () => import(/* webpackChunkName: "fro" */ '@/views/FROList/FROList');
// const AircraftInfo = () => import(/* webpackChunkName: "aircraft" */ '@/views/AircraftInfo/AircraftInfo');
// const AircraftDetail = () => import(/* webpackChunkName: "aircraft" */ '@/views/AircraftInfo/AircraftDetail');
// const ICListSelector = () => import(/* webpackChunkName: "iclist" */ '@/views/ICList/ICListSelector');
// const ICListBy = () => import(/* webpackChunkName: "iclist" */ '@/views/ICList/ICListBy');
// const ICList = () => import(/* webpackChunkName: "iclist" */ '@/views/ICList/ICList');
// const ICListDetail = () => import(/* webpackChunkName: "iclist" */ '@/views/ICList/ICListDetail');
// const StaffDirectory = () => import(/* webpackChunkName: "staffdirectory" */ '@/views/StaffDirectory/StaffDirectory');
// const StaffDirectoryCharters = () => import(/* webpackChunkName: "staffdirectory" */ '@/views/StaffDirectory/StaffDirectoryCharters');
// const StaffDirectoryDuties = () => import(/* webpackChunkName: "staffdirectory" */ '@/views/StaffDirectory/StaffDirectoryDuties');
// const StaffDirectoryStaff = () => import(/* webpackChunkName: "staffdirectory" */ '@/views/StaffDirectory/StaffDirectoryStaff');
// const MishapReport = () => import(/* webpackChunkName: "misc" */ '@/views/MishapReport');
// const Form14 = () => import(/* webpackChunkName: "form14" */ '@/views/Form14');

import Told from '@/views/Told/ToldMain';
import CallsignSearch from '@/views/Callsign/CallsignSearch';
import CallsignResults from '@/views/Callsign/CallsignResults';
import InProgress from '@/views/InProgress';
import MemberInfoSelector from '@/views/MemberInfo/MemberInfoSelector';
import MemberInfoDetail from '@/views/MemberInfo/MemberInfoDetail';
import MemberInfoList from '@/views/MemberInfo/MemberInfoList';
import CheckPilotListUnits from '@/views/CheckPilotList/CheckPilotListUnits';
import CheckPilotListTypes from '@/views/CheckPilotList/CheckPilotListTypes';
import CheckPilotList from '@/views/CheckPilotList/CheckPilotList';
import CheckPilotListDetail from '@/views/CheckPilotList/CheckPilotListDetail';
import FROListGroups from '@/views/FROList/FROListGroups';
import FROList from '@/views/FROList/FROList';
import AircraftInfo from '@/views/AircraftInfo/AircraftInfo';
import AircraftDetail from '@/views/AircraftInfo/AircraftDetail';
import ICListSelector from '@/views/ICList/ICListSelector';
import ICListBy from '@/views/ICList/ICListBy';
import ICList from '@/views/ICList/ICList';
import ICListDetail from '@/views/ICList/ICListDetail';
import StaffDirectory from '@/views/StaffDirectory/StaffDirectory';
import StaffDirectoryCharters from '@/views/StaffDirectory/StaffDirectoryCharters';
import StaffDirectoryDuties from '@/views/StaffDirectory/StaffDirectoryDuties';
import StaffDirectoryStaff from '@/views/StaffDirectory/StaffDirectoryStaff';
import MishapReport from '@/views/MishapReport';
import Form14 from '@/views/Form14';
import WMAO from '@/views/WMAO/wmao';
import PositionReport from '@/views/PositionReport';
import SpecialtyDataCollector from '@/views/SpecialtyDataCollector/SpecialtyDataCollector';
import O365LicenseRequest from '@/views/O365LicenseRequest/o365TOS';
import WingSelector from '@/views/WingSelector';
import SkillEvaluator from '@/views/SkillEvaluator/SkillEvaluator';
import SkillEvaluatorByGroup from '@/views/SkillEvaluator/SkillEvaluatorByGroup';
import SkillEvaluatorByRating from '@/views/SkillEvaluator/SkillEvaluatorByRating';
import SkillEvaluatorByRatingMembers from '@/views/SkillEvaluator/SkillEvaluatorByRatingMembers';
import SkillEvaluatorByUnit from '@/views/SkillEvaluator/SkillEvaluatorByUnit';
import SkillEvaluatorByUnitMembers from '@/views/SkillEvaluator/SkillEvaluatorByUnitMembers';
import SpecialtyTracks from '@/views/SpecialtyTracks/SpecialtyTracks';
import SpecialtyTracksByGroup from '@/views/SpecialtyTracks/SpecialtyTracksByGroup';
import SpecialtyTracksByTrack from '@/views/SpecialtyTracks/SpecialtyTracksByTrack';
import SpecialtyTracksByTrackMembers from '@/views/SpecialtyTracks/SpecialtyTracksByTrackMembers';
import SpecialtyTracksByUnit from '@/views/SpecialtyTracks/SpecialtyTracksByUnit';
import SpecialtyTracksByUnitMembers from '@/views/SpecialtyTracks/SpecialtyTracksByUnitMembers';

Vue.use(Router);


function requireAuth(to, from, next) {
  if (!auth.auth.isUserSignedIn()) {
    UserInfoStore.setLoggedIn(false);
    next({
      
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else
  {
    UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);
      //console.log(response);
      next();
    });
  }
}

//export default new Router({
const router = new Router({  
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/told',
      name: 'Told',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Told/ToldMain"),
      component: Told,
      beforeEnter: requireAuth
    },
    {
      path: '/specialtydatacollector',
      name: 'SpecialtyDataCollector',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Told/ToldMain"),
      component: SpecialtyDataCollector,
      beforeEnter: requireAuth
    },
    {
      path: '/o365tos/:securestring',
      alias: '/168a8162-f693-49cd-8c1a-fcc3be668335/:securestring',
      name: 'o365tos',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Callsign/CallsignSearch"),
      component: O365LicenseRequest,
      props: true
    },
    {
      path: '/wmao',
      name: 'WMAO',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Callsign/CallsignSearch"),
      component: WMAO,
      beforeEnter: requireAuth
    },
    {
      path: '/positionreport',
      name: 'PositionReport',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Callsign/CallsignSearch"),
      component: PositionReport,
      beforeEnter: requireAuth
    },
    {
      path: '/callsignsearch',
      name: 'CallsignSearch',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Callsign/CallsignSearch"),
      component: CallsignSearch,
      beforeEnter: requireAuth
    },
    {
      path: '/callsignresults',
      name: 'CallsignResults',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/Callsign/CallsignSearch"),
      component: CallsignResults,
      beforeEnter: requireAuth
    },
    {
      path: '/inprogress',
      name: 'InProgress',
      //component: () => import(/* webpackChunkName: 'InProgress' */"../views/InProgress"),
      component: InProgress
    },
    {
      path: '/memberinfo',
      name: 'MemberInfoSelector',
      //component: () => import(/* webpackChunkName: 'MemberInfoSelector' */"../views/MemberInfo/MemberInfoSelector"),
      component: MemberInfoSelector,
      beforeEnter: requireAuth
    },
    {
      path: '/memberinfo/type/email/:emailaddress',
      name: 'MemberInfoDetailEmail',
      //component: () => import(/* webpackChunkName: 'MemberInfoDetailEmail' */"../views/MemberInfo/MemberInfoDetail"),
      component: MemberInfoDetail,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/memberinfo/type/capid/:capid',
      name: 'MemberInfoDetailCapid',
      //component: () => import(/* webpackChunkName: 'MemberInfoDetailCapid' */"../views/MemberInfo/MemberInfoDetail"),
      component: MemberInfoDetail,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/memberinfo/type/lastname/:lastName',
      name: 'MemberInfoList',
      //component: () => import(/* webpackChunkName: 'MemberInfoList' */"../views/MemberInfo/MemberInfoList"),
      component: MemberInfoList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/checkpilotlist',
      name: 'CheckPilotListUnits',
      //component: () => import(/* webpackChunkName: 'CheckPilotListUnits' */"../views/CheckPilotList/CheckPilotListUnits"),
      component: CheckPilotListUnits,
      beforeEnter: requireAuth
    },
    {
      path: '/checkpilotlist/:groupId',
      name: 'CheckPilotListTypes',
      //component: () => import(/* webpackChunkName: 'CheckPilotListTypes' */"../views/CheckPilotList/CheckPilotListTypes"),
      component: CheckPilotListTypes,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/checkpilotlist/:groupId/:typeId',
      name: 'CheckPilotList',
      //component: () => import(/* webpackChunkName: 'CheckPilotList' */"../views/CheckPilotList/CheckPilotList"),
      component: CheckPilotList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/checkpilotlist/:groupId/:typeId/:capId',
      name: 'CheckPilotListDetail',
      //component: () => import(/* webpackChunkName: 'CheckPilotListDetail' */"../views/CheckPilotList/CheckPilotListDetail"),
      component: CheckPilotListDetail,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/frolist',
      name: 'FROListGroups',
      //component: () => import(/* webpackChunkName: 'FROListGroups' */"../views/FROList/FROListGroups"),
      component: FROListGroups,
      beforeEnter: requireAuth
    },
    {
      path: '/frolist/:groupId',
      name: 'FROList',
      //component: () => import(/* webpackChunkName: 'FROList' */"../views/FROList/FROList"),
      component: FROList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/aircraftinfo',
      name: 'AircraftInfo',
      //component: () => import(/* webpackChunkName: 'AircraftInfo' */"../views/AircraftInfo/AircraftInfo"),
      component: AircraftInfo,
      beforeEnter: requireAuth
    },
    {
      path: '/aircraftinfo/:TailNumber',
      name: 'AircraftDetail',
      //component: () => import(/* webpackChunkName: 'AircraftDetail' */"../views/AircraftInfo/AircraftDetail"),
      component: AircraftDetail,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/iclistselector',
      name: 'ICListSelector',
      //component: () => import(/* webpackChunkName: 'ICListSelector' */"../views/ICList/ICListSelector"),
      component: ICListSelector,
      beforeEnter: requireAuth
    },
    {
      path: '/iclistselector/iclistby/:typeId',
      name: 'ICListBy',
      //component: () => import(/* webpackChunkName: 'ICListBy' */"../views/ICList/ICListBy"),
      component: ICListBy,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/iclistselector/iclistby/:typeId/:valueId',
      name: 'ICList',
      //component: () => import(/* webpackChunkName: 'ICList' */"../views/ICList/ICList"),
      component: ICList,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/iclistselector/iclistby/:typeId/:valueId/:capId',
      name: 'ICListDetail',
      //component: () => import(/* webpackChunkName: 'ICListDetail' */"../views/ICList/ICListDetail"),
      component: ICListDetail,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator',
      name: 'SkillEvaluator',
      component: SkillEvaluator,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator/byrating',
      name: 'SkillEvaluatorByRating',
      component: SkillEvaluatorByRating,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator/byrating/:achvid',
      name: 'SkillEvaluatorByRatingMembers',
      component: SkillEvaluatorByRatingMembers,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator/byunit',
      name: 'SkillEvaluatorByGroup',
      component: SkillEvaluatorByGroup,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator/byunit/:groupid',
      name: 'SkillEvaluatorByUnit',
      component: SkillEvaluatorByUnit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/skillevaluator/byunit/:groupid/:orgid',
      name: 'SkillEvaluatorByUnitMembers',
      component: SkillEvaluatorByUnitMembers,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks',
      name: 'SpecialtyTracks',
      component: SpecialtyTracks,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks/bytrack',
      name: 'SpecialtyTracksByTrack',
      component: SpecialtyTracksByTrack,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks/bytrack/:spectrack',
      name: 'SpecialtyTracksByTrackMembers',
      component: SpecialtyTracksByTrackMembers,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks/byunit',
      name: 'SpecialtyTracksByGroup',
      component: SpecialtyTracksByGroup,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks/byunit/:groupid',
      name: 'SpecialtyTracksByUnit',
      component: SpecialtyTracksByUnit,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/spectracks/byunit/:groupid/:orgid',
      name: 'SpecialtyTracksByUnitMembers',
      component: SpecialtyTracksByUnitMembers,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/staffdirectory',
      name: 'StaffDirectory',
      //component: () => import(/* webpackChunkName: 'StaffDirectory' */"../views/StaffDirectory/StaffDirectory"),
      component: StaffDirectory,
      beforeEnter: requireAuth
    },
    {
      path: '/staffdirectory/:groupId',
      name: 'StaffDirectoryCharters',
      //component: () => import(/* webpackChunkName: 'StaffDirectoryCharters' */"../views/StaffDirectory/StaffDirectoryCharters"),
      component: StaffDirectoryCharters,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/staffdirectory/:groupId/:orgId',
      name: 'StaffDirectoryDuties',
      //component: () => import(/* webpackChunkName: 'StaffDirectoryDuties' */"../views/StaffDirectory/StaffDirectoryDuties"),
      component: StaffDirectoryDuties,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/staffdirectory/:groupId/:orgId/:dutyName',
      name: 'StaffDirectoryStaff',
      //component: () => import(/* webpackChunkName: 'StaffDirectoryStaff' */"../views/StaffDirectory/StaffDirectoryStaff"),
      component: StaffDirectoryStaff,
      props: true,
      beforeEnter: requireAuth
    },
    {
      path: '/mishapreport',
      name: 'MishapReport',
      //component: () => import(/* webpackChunkName: 'MishapReport' */"../views/MishapReport"),
      component: MishapReport,
      beforeEnter: requireAuth
    },
    {
      path: '/',
      alias: '',
      name: 'WingSelector',
      component: WingSelector,
      beforeEnter: requireAuth
    },
    {
      path: '/home',
      alias: '',
      name: 'Home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/index.html',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/form14',
      name: 'Form14',
      //component: () => import(/* webpackChunkName: 'Form14' */"../views/Form14"),
      component: Form14,
      beforeEnter: requireAuth
    },
    {
      // path: '/login', beforeEnter(to, from, next){
      path: '/login', beforeEnter(){
        auth.auth.getSession();
      }
    },
    {
      // path: '/login/oauth2/code/cognito', beforeEnter(to, from, next){
      path: '/login/oauth2/code/cognito', beforeEnter(){
        var currUrl = window.location.href;

        //console.log(currUrl);
        auth.auth.parseCognitoWebResponse(currUrl);
        //next();
      }
    },
    {
       // path: '/logout', component: Home,  beforeEnter(to, from, next){
      path: '/logout', name: 'Logout', component: Home,  beforeEnter(to, from, next){
        auth.logout();
        //console.log(next);
        next();
      }

    },
    {
      path: '/error', component: ErrorComponent
    }
  ]
});

Vue.use(VueRouterBackButton, { router })

// export router as default
export default router;

